export interface ApplicationState {
  onLine: boolean;
  totalStorageUsed: number;
  saveFailedDueToStorage: boolean;
  singleDocumentSizeReached: boolean;
}

export enum ApplicationStateActionName {
  SetOnLineStatus = 'rshr/system/application/set_online_status',
  SetTotalStorageUsed = 'rshr/system/application/set_total_storage_used',
  SetSaveFailedDueToStorage = 'rshr/system/application/set_save_failed_due_to_storage',
}

export interface SetOnLineStatusAction {
  type: ApplicationStateActionName.SetOnLineStatus;
  payload: {
    onLine: boolean;
  };
}

export interface SetTotalStorageUsedAction {
  type: ApplicationStateActionName.SetTotalStorageUsed;
  payload: {
    totalStorageUsed: number;
  };
}

export interface SetSaveFailedDueToStorageAction {
  type: ApplicationStateActionName.SetSaveFailedDueToStorage;
  payload: {
    saveFailedDueToStorage: boolean;
    singleDocumentSizeReached: boolean;
  };
}

export type ApplicationStateActionTypes =
  | SetOnLineStatusAction
  | SetTotalStorageUsedAction
  | SetSaveFailedDueToStorageAction;
